/// <reference path="../ResultListController.ts" />
/// <reference path="./SearchableController.ts" />
/// <reference path="../../HTML/Menu/MenuList.ts" />
namespace HA.Core.Controller.Page {
    import MenuList = HA.Core.HTML.Menu.MenuList;
    export class MenuController extends SearchableController {

        protected showSearchBox(): boolean {
            return false;
        }

        protected getResultItem() {
            return MenuList;
        }
    }
}
